
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwtF_45pKtlfZGeuaIBwim1_9PwvVaF4dxfLGn1MqiHGaggMMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseidVkRLTAnrswGIoIHkYJWJ_459jYrSnRPrvWmLEp4r827_45oMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as deposit2lD8gdoYfiro7Q68X_VC1gKZp6fTVW6RQf5R42E8bFQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45us53IcM_45BAtxysgHsp2bCauCVMGE_5PMjZDip7MT0v6B4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93vfFHPAhHlQQG9qAYt3wYkug8EQRRiN3WxbeydLYnFJQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_93UV3BaY_45btTbL7uXfkk98c2ofiTAcJIVLJbMZ1NYZGBcMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fund_45HtbMu_456VgxVwJ8HYHQsqhg9Oo0smj9L5Ct_AjJGkfgMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexqOMtQ18VbcD41DqK8lw_45_V4VHBmr3a1XEvxoo_JpdOQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseiditncqIraA52OIISCZEPWmHKLCXrXGjZ6guV35ldumwsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountpclS5ul_45bV46y9CuFR3ZAkqjBicf4Hd2xx2dFsbctmsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blockediw2pYbLj550ONeJbzdSaoJ173lMmjofm_ct5YwrV9JMMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referrallVJncITr9my8e_45HWAyW7yuslZAndtK8w_EMaPI_Wb1YMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityGDIUNk72ppLSHMnDlpEp11mePNf64ZFrycgptSMYLzEMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outtxPN61JRS2itWuAlujR1QZ5kAeWEwxG7kiKjQbiW5XwMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_93OSIJmjxocum7vve5zfk8CIIzOP_oJglTuCMcuv_J3S8Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_933i1Qw_45tEOtfGT8lP_4YiVvJywCKGOBuWV6d2ws1y0UYMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawehpayNpeGDU4s7bzTHaT3en_mAlrVH_XG_459VVb4sqzoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardGFe_4JtOQ1ZtndUCwgHE2b6yYqt1GaT2n9XfgD2__45qsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developereOiRZr0aqtmgvoUy2iRvkQeJmeYjI9Y42ayPfAEMAOsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginN9KMu7jFHlXHTVlI6F8zg2t3msV_45E3uWC8r2u2RtdC4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingdtuX5VZa4LHDz8EIlV9piMl7B6jYd3hJlW_5uOr2tkAMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundCSXA6c0qR3PbaeKr_45XTbyLJhl31Z3GLJ9gFMwTL2IlEMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2faGJqYR7avam6Pb5rHRiDOcNuXs_uwA9zfFEX64NjVml4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as index9TOrQR_Z2XSiEfJvKQmYrQ_45seE1qQ3k70JuhP3QGqmoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codetsXaIVXwWZ40pjpUKvUjKBD0QgKVuv1V2mq7k_r0skYMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as codeCmjgac7bUb6Q5Zo2Ss3wH2cVZ_5QEV11QGaB6OsTkS8Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexNAs3xOSqTlSiz1zrsDgLS_sb5HuJDh46GWKYzWeGsmEMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as register9ZsM0kfpAYWxWe1GHmtbI9ZOgGady5wB_453Oab8wHx3QMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexT_45TgEj3HQRrk4tdFA4KTo04QoGmohwmyWnRoISmzsh0Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93mDhVQ9B_455tIlLUQnJRi8SHvdYqn7QtpMI2SjzKp_S64Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexn98PqRR2AQqAnn0NudeV0DPokKO_45CoPU45Jg6LxyDEUMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45document1KUh15_45nZ6KhtGaI8GEY8RGcT9Vr47dkPOHsqKMHU3gMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as index_v0zDqlUKbMz7tpUwsRimZrZAF_Hrq7Ptihj1O7jczgMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexN1gJv_45rL7hY5JizMc5VnRbm9lJOWM9D_R7nr_RZzo0QMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importNXcFjP_45WZXJv9BXaPRSvQAQT5tt2tJLdpBoxC74EOH8Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as direct3ICup7SGDNzfryjdUmtXqmV8_iQNHAwQO5k1uPAPTecMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsuba5jOhpTG1JOlx_45iJpZOY0o9HJmPaa_EfzvQeBwyXrGUMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedXcomHdxfrnoNJCK_qGxpO0RStsCg9xoJwi61NmSOe2MMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedkASlqm9Hc1G8X9OY_45cw_SwLpFFGJf_45PiqGFQn9DhFGQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightVt6pFBQMp3B1oLBaZyFQhaOt7ZuUO8PYH_45KRrLljMFoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightoIQw4_45OnJo_GyaVG_0j4TkK1irXxY_45MLHJO9I3W_xygMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as inviteo9MdCcseO5sIqRECZemX43uPXBGlfHInKDC0WzAsphkMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexBKRPsJtfCB7py6GjKT8gULBwuLWkDo1pEHz4Y7NAPngMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexhbeMri8YJZc9eybScenhYc0HdV3c7OUGUJLIA7X51isMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waitingoAPlZUeYe24mtPsLFzoGIeIOE0lC_su9Z4XYGb9hPFsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as businessQMRfO4KvKrG9csmWRPj1xKzeUfMYxmNzJclphOhDiEkMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callback_KhbqnyIFuw5NVbQvbNvSVTbQmtXnbfvYU7dk3jFWEoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93XOYzF_wdhCkyS92Y_mAM5VuXosz4ULDS6wG5F26vrVIMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as indexW9F3kpt0qqqWo_45JfICwqs7uSjMbIuW3UYTlPz9cS7TQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93yt1ri_45bOpsUU873tpr9_45jwRal8YJ7Wii034sfSrQykMMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as indexGRDVUjFHfdklmV2MykZBfuE_45KJT1TuiviI9vHmjw_v0Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexI7mA0_9thvl_45Ca38F4M1x6NDbsuCtKyYmh6Vnd4gdkcMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexC1msKWvknBy2dD3xcwWenpvE3zSCdnU6K3DBevcAxZkMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionswgYSCzROrPkAT9CmZIiHqQjrTbDC_45g378qhdcXg2_xAMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdrawPHWDSOPGF0cEBG0fAydUcbjWpNG6OPSyJxh5WqTdNg0Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_931nLaBuQejUUoXlD77QKH8vz_45xJs2cjS_45UXPnkA1x8MoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as index6jadC0uHub6guNH_YbQ4QLwADPfYZos7KMcyt8INmLwMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexF2s_4513F1DxoIJCZbN4UZM3PHhW__45EGY4Tb9h6jYYoQEMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as indextptqRKB1YuCbmgYLl_ODczO2MCQqFM3Zgu0clxo6jTgMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as rampsRJa4mXLdxGQkF63vLBxdu4rohk0CyCzTeqQco_xJyM4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classificationaDW4z7OrpniDgHoavHXa5WW1nvwHTEQnVUdUg1eRvhwMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93wJarLgAN1cBoM5QGOE1ybIbFyeUK_5CU_yD7EIxcHYYMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45walletOQUiF5g0g2T0l9plYTepF8YNzPLmD3p23NggtpqeEgcMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addressrFeFI0FArdVpN8e9CdZYZSAtqKrKYJuIbQ9n6COtCDkMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsqaP6YhRyK5pfPZAKvIUbRjYRhCb_2C_9befaSC0Sm8kMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45historyE1uMx9QVgMWVma4mTrAED_456vuqlDzSZeVOOgcu2SGKkMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usybevOblMxSkDPvzWc1kk_meO_sL67AdgQ3dxHibrk7MMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurJrrzxDc34bTyYBpBkXiPHF0R0F0nW22Xgm_7fsrpgmIMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbp92XUjlSusCEZ2zdfTQDOrs040gDE_aDfFeXjSm42iG0Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngn7gsjywcDo3Y2HHwW0t6XF7WW8uQNrVMydeUBMpVVQZ8Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlaRIxFtcjzFOgKKSyenU1ip4F_vd9JUwD8G2rPlF9EEssMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexaw_Lnq_45rl2dcbx6BG6LO53YNpDG85MiPoGz_45nddNFsoMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakengqVbZO069mNjkx7Xn3f5fC_45sfwFOLjRNZH3ccvq3hZAMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binanceSHz7RKIpDtgf4_nUjwoyxTuMN2q6HGt7KN6Vv7lM5ycMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaserkwl92AcggE4K04cgv1_bn0wcXAHm6kABva3ngZmOCsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationalb9AmsJM5hFfFIZV3BCPgqAfMVYPlYYU7kJ2p5Pht5f0Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_wallet_aHNJCYk1ajGCyPMJzUg95Vc7cXVQtTEv42JA95jlXcMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankw8YGsyljbBPsM8dPDErILS7D3Uaw6vTLbgukih7Z698Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexZWBBLBxeuvXyZFjtX5nxOP1YgUfTiPkFfIPtqHSOsgQMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_93Siu0HdxuV0iiiFCk7uvDIegByWuczpj8gXWRQpYccsgMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as optionspoDAIAdRvoQyxrysYB7J1gEU2DaeF3n1DM7q_Vt382QMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbaseCJ8_K_xLzrexhyq7GXcs95u7y_45e_45GvkLqq6EOKDLhnsMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamBipeojh5V95kRSKYtEthGMcdLGA968DhZkAZulER518Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93tGqJtwuLR0YaH93bT_EyPEae9aOdK_8lHv1mnVLPDd4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexj4YoLum_H_Vs3prxTa4oUTLl0_45BfNe3Cwd_MX6_45gjy4Meta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletq_kRyH3DbMwtwrerzG4Cz0LSEjqCGUg7pJmfuYkyEjUMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_scheduleTZCRlSctn169c5lEYtuQBzUyVSBJwyyE3MThmXHuK2sMeta } from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwtF_45pKtlfZGeuaIBwim1_9PwvVaF4dxfLGn1MqiHGaggMMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fund_45HtbMu_456VgxVwJ8HYHQsqhg9Oo0smj9L5Ct_AjJGkfgMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidVkRLTAnrswGIoIHkYJWJ_459jYrSnRPrvWmLEp4r827_45oMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: deposit2lD8gdoYfiro7Q68X_VC1gKZp6fTVW6RQf5R42E8bFQMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45us53IcM_45BAtxysgHsp2bCauCVMGE_5PMjZDip7MT0v6B4Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93vfFHPAhHlQQG9qAYt3wYkug8EQRRiN3WxbeydLYnFJQMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_93UV3BaY_45btTbL7uXfkk98c2ofiTAcJIVLJbMZ1NYZGBcMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexqOMtQ18VbcD41DqK8lw_45_V4VHBmr3a1XEvxoo_JpdOQMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseiditncqIraA52OIISCZEPWmHKLCXrXGjZ6guV35ldumwsMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountpclS5ul_45bV46y9CuFR3ZAkqjBicf4Hd2xx2dFsbctmsMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockediw2pYbLj550ONeJbzdSaoJ173lMmjofm_ct5YwrV9JMMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referrallVJncITr9my8e_45HWAyW7yuslZAndtK8w_EMaPI_Wb1YMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityGDIUNk72ppLSHMnDlpEp11mePNf64ZFrycgptSMYLzEMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outtxPN61JRS2itWuAlujR1QZ5kAeWEwxG7kiKjQbiW5XwMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawehpayNpeGDU4s7bzTHaT3en_mAlrVH_XG_459VVb4sqzoMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardGFe_4JtOQ1ZtndUCwgHE2b6yYqt1GaT2n9XfgD2__45qsMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developereOiRZr0aqtmgvoUy2iRvkQeJmeYjI9Y42ayPfAEMAOsMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingdtuX5VZa4LHDz8EIlV9piMl7B6jYd3hJlW_5uOr2tkAMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: index9TOrQR_Z2XSiEfJvKQmYrQ_45seE1qQ3k70JuhP3QGqmoMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexNAs3xOSqTlSiz1zrsDgLS_sb5HuJDh46GWKYzWeGsmEMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexT_45TgEj3HQRrk4tdFA4KTo04QoGmohwmyWnRoISmzsh0Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexn98PqRR2AQqAnn0NudeV0DPokKO_45CoPU45Jg6LxyDEUMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45document1KUh15_45nZ6KhtGaI8GEY8RGcT9Vr47dkPOHsqKMHU3gMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index_v0zDqlUKbMz7tpUwsRimZrZAF_Hrq7Ptihj1O7jczgMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importNXcFjP_45WZXJv9BXaPRSvQAQT5tt2tJLdpBoxC74EOH8Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: inviteo9MdCcseO5sIqRECZemX43uPXBGlfHInKDC0WzAsphkMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexBKRPsJtfCB7py6GjKT8gULBwuLWkDo1pEHz4Y7NAPngMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexhbeMri8YJZc9eybScenhYc0HdV3c7OUGUJLIA7X51isMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingoAPlZUeYe24mtPsLFzoGIeIOE0lC_su9Z4XYGb9hPFsMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: businessQMRfO4KvKrG9csmWRPj1xKzeUfMYxmNzJclphOhDiEkMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93XOYzF_wdhCkyS92Y_mAM5VuXosz4ULDS6wG5F26vrVIMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexW9F3kpt0qqqWo_45JfICwqs7uSjMbIuW3UYTlPz9cS7TQMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93yt1ri_45bOpsUU873tpr9_45jwRal8YJ7Wii034sfSrQykMMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: indexGRDVUjFHfdklmV2MykZBfuE_45KJT1TuiviI9vHmjw_v0Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexI7mA0_9thvl_45Ca38F4M1x6NDbsuCtKyYmh6Vnd4gdkcMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexC1msKWvknBy2dD3xcwWenpvE3zSCdnU6K3DBevcAxZkMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionswgYSCzROrPkAT9CmZIiHqQjrTbDC_45g378qhdcXg2_xAMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdrawPHWDSOPGF0cEBG0fAydUcbjWpNG6OPSyJxh5WqTdNg0Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_931nLaBuQejUUoXlD77QKH8vz_45xJs2cjS_45UXPnkA1x8MoMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: index6jadC0uHub6guNH_YbQ4QLwADPfYZos7KMcyt8INmLwMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexF2s_4513F1DxoIJCZbN4UZM3PHhW__45EGY4Tb9h6jYYoQEMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indextptqRKB1YuCbmgYLl_ODczO2MCQqFM3Zgu0clxo6jTgMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: rampsRJa4mXLdxGQkF63vLBxdu4rohk0CyCzTeqQco_xJyM4Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificationaDW4z7OrpniDgHoavHXa5WW1nvwHTEQnVUdUg1eRvhwMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93wJarLgAN1cBoM5QGOE1ybIbFyeUK_5CU_yD7EIxcHYYMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsqaP6YhRyK5pfPZAKvIUbRjYRhCb_2C_9befaSC0Sm8kMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45historyE1uMx9QVgMWVma4mTrAED_456vuqlDzSZeVOOgcu2SGKkMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: optionspoDAIAdRvoQyxrysYB7J1gEU2DaeF3n1DM7q_Vt382QMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamBipeojh5V95kRSKYtEthGMcdLGA968DhZkAZulER518Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93tGqJtwuLR0YaH93bT_EyPEae9aOdK_8lHv1mnVLPDd4Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexj4YoLum_H_Vs3prxTa4oUTLl0_45BfNe3Cwd_MX6_45gjy4Meta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletq_kRyH3DbMwtwrerzG4Cz0LSEjqCGUg7pJmfuYkyEjUMeta || {},
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]